import React, { useEffect, useState } from "react";
import {
    CustomCheckboxSmall,
    CustomDeleteButton,
    CustomDoubleButton,
    IconsArea,
    RowDiv,
    SettingsInfo,
    TickerItemDiv,
    ToolLabel,
} from "./mDPSettingsBlockStyles";
import { CheckboxChangeEvent } from "antd/lib/checkbox/Checkbox";
import { BasedSelect } from "components/Selects/BasedSelect";
import { Select } from "antd";
import { useAppSelector } from "../../../hooks/redux";
import { RootState } from "store/store";

const { Option } = Select;

interface IProps {
    onSettingClick: () => void;
    makeCopyOfTheMDP: () => void;
    onDeleteClick: () => void;
    onIsActiveChange: (checkValue: boolean, explicitMDPName?: string ) => void;
    onSelectChange: (e: string) => void;
    setIsActiveMDPs: React.Dispatch<React.SetStateAction<Set<string>>>;
    isActive: boolean;
    source: string;
    sourceType: string;
    isDisabled: boolean;
    isSelected: boolean;
    from_sp?: string[];
}

const MDPSettingsItem = ({
    onSettingClick,
    isActive,
    source,
    sourceType,
    setIsActiveMDPs,
    makeCopyOfTheMDP,
    onDeleteClick,
    onSelectChange,
    onIsActiveChange,
    isSelected,
    from_sp,
}: IProps) => {
    const [sourceBase] = useState([sourceType, isActive]);
    const [isSelectChanged, setIsSelectChanged] = useState(false);
    const [isActiveChanged, setIsActiveChanged] = useState(false);
    const [currentOptionVal, setCurrentOptionVal] = useState<string>("")
    const MDPTypes = useAppSelector((state) => state.settings.MDPTypes);
    const MDPValuesToChange = useAppSelector((state: RootState) => state.settings.savedSettings.MDP.values);

    const middlewareOnDeleteClick = () => {
        setIsActiveMDPs((prev) => {
            const newState = new Set(prev)
            newState.delete(source)
            return newState
        })
        onDeleteClick()
    }

    const middlewareSelectChange = (selectedValue: string) => {
        onSelectChange(selectedValue)
        setCurrentOptionVal(selectedValue)
        if (selectedValue.toString() === sourceBase[0]) {
            setIsSelectChanged(false)
        } else {
            setIsSelectChanged(true)
        }
    };
    const middlewareIsActiveChange = (isChecked: boolean, explicitName: string) => {
        isChecked === sourceBase[1]
            ? setIsActiveChanged(false)
            : setIsActiveChanged(true);
        onIsActiveChange(isChecked, explicitName);
        isChecked ? (
            setIsActiveMDPs((prev) => new Set(prev).add(explicitName))
        ) : (
            setIsActiveMDPs((prev) => {
                const newState = new Set(prev)
                newState.delete(explicitName)
                return newState
            })
        )
    };

    useEffect(() =>{
        if(currentOptionVal && isActiveChanged){
            middlewareSelectChange(currentOptionVal)
        }
    },[currentOptionVal, isActiveChanged])

    return (
        <TickerItemDiv
            style={{
                paddingRight: 0,
            }}
            isSelected={isSelected}
        >
            <SettingsInfo>
                <RowDiv>
                    <CustomCheckboxSmall
                        type="checkbox"
                        checked={isActive}
                        ischanged={isActiveChanged}
                        onChange={(e: CheckboxChangeEvent) =>
                            middlewareIsActiveChange(e.target.checked, source)
                        }
                    />
                    <ToolLabel onClick={isActive ? onSettingClick : undefined}>
                        { /* because we are actually not making a copy, "::copy" play the diff factor between two params */ }
                        {source.replace("::copy", "")} 
                    </ToolLabel>
                </RowDiv>
                <RowDiv>
                    <BasedSelect
                        size={"small"}
                        // here we first find a desired tuple of our current element (values[2] is a name) and then extract the option value from it [3]
                        value={MDPValuesToChange.find((values) => values[2] === source)?.[3]} 
                        onChange={(selectedValue: string) =>
                            middlewareSelectChange(selectedValue)
                        }
                        isChanged={isSelectChanged}
                        isDisabled={!isActive}
                        isselected={isSelected}
                    >
                        {MDPTypes?.map((option) => (
                            <Option value={option} key={option}>
                                {option}
                            </Option>
                        ))}
                    </BasedSelect>
                </RowDiv>
            </SettingsInfo>
                <IconsArea>
                    <CustomDoubleButton onClick={() => {
                        makeCopyOfTheMDP()
                        middlewareIsActiveChange(true, source + "::copy") // because we need to have a diff beetween copy and orig MDP
                        }} />
                    {source.includes("copy") && (
                        <CustomDeleteButton onClick={middlewareOnDeleteClick} />
                    )}
                </IconsArea>
        </TickerItemDiv>
    );
};

export default MDPSettingsItem;
